export default {
  'selectBranch': 'Select Counter', // 选择店铺
  'noneBranch': 'No store found', // 未查询到店铺
  'currentCall': 'Current', // 当前叫号
  'currentPeople': 'Crowd', // 当前人数
  'estimatedTime': 'Wait', // 预计时间
  'orderPrompt': 'Delicious, Come to buy ~', // 美味多多,快来选购~
  'goOrder': 'Next', // 去下订单
  'selectedGoods': 'Selected Goods', // 已选商品
  'clearCart': 'Clear Cart', // 清楚购物车
  'noSelectShop': 'I haven not chosen a course yet', // 
  'editNum': 'Modified Quantity',
  'soldOut': 'Be Sold Out',
  'lifting': 'The difference is {0} yuan',
  'enterOrderQuantity': 'Please enter order quantity',
  orderCancel: 'Cancel',
  confirm: 'Confirm',
  Insufficient: 'Insufficient stock',
  purchaseLimit: 'Exceed the purchase limit',
  nullExplain: 'Please enter',
  reserveType: 'Dining Type',
  reserveTypeTip: 'Please select dining type',
  reserveType1: 'Delivery',
  reserveType2: 'Dine-in',
  reserveType3: 'Pickup',
  reserveTime: 'Dining time',
  shopAddress: 'Address',
  paymentType: 'Payment Method',
  // Please select payment method
  paymentTypeTip: 'Please select payment method',
  noneAccount: 'There are no available pending accounts',
  shippingAddress: 'Delivery Address',
  shippingAddressTip: 'Click to Select Address',
  // Please select delivery address
  shippingAddressTip2: 'Please select delivery address',
  shippingTime: 'Delivery Time',
  shippingTimeTip: 'Please select delivery time',
  // Storage
  storage: 'Lockers',
  // Reheat
  warm: 'Reheat',
  name: 'name',
  phone: 'phone',
  nameExplain: 'Please enter your name',
  phoneExplain: 'Please enter your phone',
  // Please select storage cabinet
  storageCabinetTip: 'Please select lockers',

  packageFee: 'Packing Fee',
  shippingFee: 'Delivery Fee',
  // Storage Fee
  storageFee: 'Lockers Fee',
  warmFee: 'Warming Fee',
  discountPriceFee: 'Discount',
  totalFee: 'Total',
  cardPay: 'Card wallet payment',
  orderRemark: 'Remarks',
  orderRemarkTip: 'Flavor, Preferences, etc.',
  orderSubmit: 'Submit',
  selectDiscount: 'Select coupon',
  yuan: 'yuan',
  fold: 'fold',
  noneMoney: 'No money gate',
  section: 'section',
  common: 'Be common',
  noData: 'No data available',
  select: 'Select',
  correctPhone: 'Please enter the correct phone number',
  paymentIn: 'In payment',
  // Confirm Payment
  confirmPay: 'Confirm Payment',

  paySuccess: 'Payment Successful',
  payOrderSuccess: 'Order Placed Successfully',
  paySuccessTip: 'Please go to the pick-up counter and collect your meal with your pick-up number',
  paySuccessTip2: 'Order as needed, prevent waste, everyone is responsible',
  paySuccessReserveTime: 'Dining Time',
  payTotalFee: 'Total Amount Paid',
  orderNo: 'Order No',
  // Dining Time:
  continueOrder: 'Continue Ordering',
  // View Details
  viewDetail: 'View Details',

  scrollDeliciousBottom: 'Delicious to the Bottom',
  appointmentTime: 'Appointment Time',
  orderTimeDate: 'Order time',
  noMore: 'No more',
  loading: 'Loading',
  // Completed
  orderStatus01: 'Done',
  // Refunded
  orderStatus02: 'Refunded',
  // Unpaid
  orderStatus03: 'Unpaid',
  orderStatus04: 'In delivery',
  orderTime: 'Order time',
  totalCount: 'total {0} items',
  oneOrder: 'One more',
  cancelOrder: 'Cancel',
  cancelOrderPlaceholder: 'Are you sure you want to cancel this order?',
  repayBtn: 'Repay',
  repayOrderPlaceholder: 'Are you sure you want to make the payment again?',
  confirmOneTip: 'Are you sure you want another order？',
  successTip: 'Recharge successful',
  foodNumber: 'Pick-up code',
  dishDetail: 'Menu of dishes',
  totalDish: 'total {0} items',
  refundMoney: 'Refund amount',
  currentShopTip: 'Current merchant',
  shopView: 'View',
  cardInfo: 'Card Info',
  employeeInfo: 'Employee No.',
  mainCard: 'Main Card',
  merchantTitle: 'Merchant switching',
  switchTips: 'The app will be reloaded after switching merchants, please confirm',
  accountLabel: 'Accpunt',
  accountTips: 'Please select a accpunt',
  moneyLabel: 'Amount',
  moneyTips: 'Please select the account',
  rangeConfirm: 'Recharge',
  moneyTips2: 'Please enter an amount greater than 0',
  feedCommentsTips: 'Honey! You have not made any comments!',
  forwardTips: 'Look forward to your feedback!',
  feedBackText: 'Feedback',
  opinionType: 'Issue type',
  branchLabel: 'Store',
  problemLabel: 'Description',
  problemPlaceholder: 'Please enter your feedback',
  uploadPic: 'Upload the image.',
  submitBtn: 'Submit',
  returnBtn: 'Back',
  submitSuccessTip: 'Submit successfully',
  secondsBack: 'Return in {0} seconds',
  noBranchTips: 'Please select a stall',
  feedBackStatus1: 'New',
  feedBackStatus2: 'Confirmed',
  feedDetailStatus1: 'Submit',
  feedDetailStatus2: 'Verify',
  feedDetailStatus3: 'doing',
  problemSpot: 'Point of issue',
  description: 'Description',
  messageTitle: 'Message',
  messagePlaceholder: 'Please enter a message',
  send: 'send',
  successText: 'Refresh successfully',
  pullingText: 'Pull down refresh',
  loosingText: 'Release to refresh',
  progressStatus1: 'Under way',
  progressStatus2: 'ProgressiGn',
  progressStatus3: 'End',
  progressStatus4: 'Submitted',
  progressStatus5: 'Not done',
  unlimit: 'Unlimited',
  cutoff: ' Deadline',
  minSelect: 'Select at least {0}',
  maxSelect: 'Select a maximum of {0}',
  calendar: 'CAL',
  calendarTitle: 'Date selection',
  week_一: 'Mon',
  week_二: 'Tue',
  week_三: 'Wed',
  week_四: 'Thur',
  week_五: 'Fri',
  week_六: 'Sat',
  week_日: 'Sun',
  repastAddress: 'Address',
  completionTime: 'Delivery completion time',
  remark: 'Remarks',
  attachments: 'attachments',
  locationTabbar1: 'Room List',
  locationTabbar2: 'Order Record',
  insOutsText: 'Select Counter',
  capacity: 'Support',
  capacityUnit: 'people',
  reserveStatus1: 'Booking',
  reserveStatus2: 'Unavailable',
  reserveStatus3: 'Submit reservation',
  reserveStatus4: 'Successful booking',
  reserveStatus5: 'Booking details',
  reserveStatus6: 'Cancel',
  recordsDateText: 'Meal date screening',
  recordsStatusText: 'Predetermined state',
  dinersNum: 'Number of diners',
  numberId: 'ID',
  accommodatePeople: 'Support {0} people',
  reserveNameLabel: 'Booker',
  reserveNamePlaceholder: 'Please fill in the booker',
  reservePhoneLabel: 'Phone No',
  reservePhonePlaceholder: 'Please fill in the phone no',
  reserveNumLabel: 'Number of diners',
  reserveNumLabel2: 'Number of diners',
  reserveNumPlaceholder: 'Number of diners',
  reserveTimeLabel: 'Meal time',
  reserveTimeLabel2: 'mealtime',
  orderInfoTitle: 'Order Info',
  reserveTimePlaceholder: 'Meal time',
  reserveExtraLabel: 'Private room service',
  reserveExtraPlaceholder: 'Please fill in the private room service',
  remarkPlaceholder: 'Enter tastes, preferences etc',
  reserveBtn1: 'rebook',
  reserveBtn2: 'Submit',
  reserveBtn3: 'Further booking',
  reserveBtn4: 'View appointment',
  dateTimePickerTitle: 'Selection time',
  noBRanch: 'Unclear stall',
  loginTitle: 'Merchant login',
  loginAccountPlaceholder: 'Please enter your employee number',
  loginPasswordPlaceholder: 'Please enter password',
  loginPhonePlaceholder: 'Please enter phone',
  loginVerificationCodePlaceholder: 'Please enter verificationCode',
  loginBtn: 'Log in',
  loginBtnIng: 'Be logging in',
  workshopTabbar1: 'Counter list',
  workshopTabbar2: 'Order list',
  workshopNameLabel: 'Booker',
  workshopNamePlaceholder: 'username',
  workshopRadioLabel: 'Cost center',
  workshopAddress: 'Please choose',
  workshopTimeLabel: 'Order Time',
  workshopTimePlaceholder: 'Click to select date',
  workshopDishLabel: 'Menu of dishes',
  noSelectTips: 'Please choose to order dishes!',
  workshopTitle: 'Select Counter',
  updatePasswordTitle: 'Change password',
  cardPackageTitle: 'Select Dishes',
  packageFormTitle: 'Book Info',
  branchTitle: 'Select Counter',
  orderTitle: 'Order list',
  submitOrderTitle: 'Submit an order',
  mineTitle: 'mine',
  addAddressTitle: 'Add address',
  orderDetailTitle: 'Order details',
  selectAddressTitle: 'Select address',
  quitSuccessTips: 'Exit successfully',
  rangeTitle: 'Recharge',
  homeTitle: 'Home page',
  reserveListTitle: 'Reservation list',
  reserveResultTitle: 'Predetermined result',
  evaluationTitle: 'Survey List',
  evaluationContentTitle: 'Questionnaire content',
  evaluationExplainTitle: 'Questionnaire prompt page',
  feedbackTitle: 'feedback',
  submitFeedTitle: 'Submit suggestions',
  feedDetailTitle: 'Feedback details',
  changeShopTitle: 'My card bag',
  cardDetailTitle: 'Card details',
  noPromises: 'No permission',
  pageTitle: 'Basf order',
  explainSuccessTips: 'Questionnaire submission successful',
  surveySuccessTips: 'Thank you for your support of this survey',
  noStartStatusTips: 'The questionnaire survey has not yet begun',
  noStartSurveyTips: 'The survey questionnaire collection time has not yet started',
  stopStatusTips: 'End of questionnaire survey',
  stopSurveyTips: 'The collection time of this survey questionnaire is over',
  errorStatusTips: 'Access failure',
  errorSurveyTips: 'The access failed because the questionnaire does not exist',
  statusStr0: 'ALL',
  statusStr1: 'On-going',
  statusStr2: 'Cancelled',
  statusStr3: 'Done',
  statusStr4: 'Qingtai',
  statusStr5: 'Clear',
  statusStr6: 'Expired',
  dialogTitle1: 'Cancel reservation',
  dialogMessage: 'Whether to cancel the reservation',
  cancelSuccess: 'Cancel successfully',
  cancelFinal: 'Cancellation failure',
  cancelTime: 'Cancel time',
  cancelReason: 'Reason',
  useTime: 'Usage time',
  updateReserve: 'Modify reservation',
  cancelReason1: 'Self-cancellation',
  cancelReason2: 'The background CMS cancellation operation',
  cancelReason3: 'The table reservation has been cancelled in the background',
  cancelReason4: 'The guest has not arrived yet.',
  addressTip1: 'Please select the building.',
  addressTip2: 'Please select point.',
  addressBtn: 'Confirm the address',
  plantOrderTitle: 'Plant Ordering',
  refundStatus1: 'No refund',
  refundStatus2: 'Refunding',
  refundStatus3: 'Refund failed',
  refundStatus4: 'Refund successful',
  refundStatus5: 'Partial refund in progress',
  refundStatus6: 'Partial refund failure',
  refundStatus7: 'Partial refund successful',
  locationTabbarTitle: 'VIP Room Reservation',
  loginSuccess: 'Login successful',
  passwordTitle: 'Change the password',
  updatePasswordPlace: 'Please enter the new password',
  updating: 'Under revision',
  updateTips: 'Modify',
  passwordRules: 'Please enter an 8-16 password (including both upper and lower case and special characters).',
  flowCrowd: 'Foot Traffic',
  scanLoginTitle: 'Login of third-party personnel',
  getVCode: 'Get Verify Code',
  loginToastSendSuccess: 'Sent successfully',
  cardMoney: 'Balance of meal card',
  CombinedPayment: 'Combined payment',
  noBalance: 'Insufficient balance',
  wxPay: 'Wechat pay',
  select_meal: 'Select meal',
  reserve_status: 'Delivery status',
  deliveryStr1: 'To be delivered',
  verification: 'Please enter a quantity greater than 0',
}
